module.exports = __webpack_public_path__ + "img/K16.ade4d1fd.png";